import { type ReactNode, useEffect, useState } from "react"
import { SPOILER_REHIDE_MS } from "@/shared/lib/spoiler"

/** Спойлер с частицами, как в Telegram: открывается по нажатию и через три секунды прячется снова. */
export function Spoiler({ children }: { children: ReactNode }) {
	const [round, setRound] = useState(0)
	const [opened, setOpened] = useState(false)
	useEffect(() => {
		if (!opened) return
		const timer = window.setTimeout(() => {
			setOpened(false)
			setRound((value) => value + 1)
		}, SPOILER_REHIDE_MS)
		return () => window.clearTimeout(timer)
	}, [opened])
	return (
		<spoiler-span key={round} data-react-spoiler="" density="5" onClick={() => setOpened(true)}>
			{children}
		</spoiler-span>
	)
}
